/*
 * @author Igor Serpak <robobee>
 */
angular.module('data.security-manager', []);
